/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useAppStore } from "../../store/models/app";

function useInAppRedirect () {
    const appStore = useAppStore();

    useEffect(() => {
        console.log('useInAppRedirect()');
        setTimeout(() => appStore.initAsInAppRedirect(), 200);
    }, []);

    return {
    };
}

export default useInAppRedirect;
